module.exports = __webpack_public_path__ + "static/img/banner_home.266ab27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_home.jpg
// module id = fqD9
// module chunks = 15